import hubapiStack from 'hub-http/stacks/hubapi';
import noAuthWithCredentialsHubapi from 'hub-http/stacks/noAuthWithCredentialsHubapi';
import Client from 'in-meeting-experience-ui-components/utils/apiClient/client';
import { acceptanceTestBaseRoute, routes } from '../constants/routes';
import thirdPartyAuthErrorMiddleware from './thirdPartyAuthErrorMiddleware';
export const baseHttpClient = new Client({
  clientStack: hubapiStack
});
export default new Client({
  clientStack: noAuthWithCredentialsHubapi,
  unauthorizedUrl: routes.reconnect,
  accountsUrl: routes.accounts,
  acceptanceTestBaseRoute,
  middlewares: [thirdPartyAuthErrorMiddleware]
});